// 动态组件载入口
import { requireFiles } from 'common/utils'

export default requireFiles(require.context('./dynamicComponents', true, /\.js$/))
